import { MINIMUM_DOSE, MAXIMUM_DOSE, DOSE_STEP} from '../shared/constants.js';
import { useLanguage } from '../context/LanguageContext.js';
import { usei18n } from '../i18n/i18n.js';
import './DoseSelector.css';

const Presets = ({presets, selected, selectDose}) => {
    return (
        <div className="presets">
            {presets.map(preset => {
                const isSelected = selected === preset;
                return (
                    <button
                        key={preset}
                        onClick={() => selectDose(preset)}
                        className={`preset ${isSelected ? 'selected' : ''}`}
                    >{preset}</button>
                )
            })}
        </div>
    )
}

const DoseStepper = ({selected, onChange, i18n}) => {
    const value = parseFloat(selected);

    const decrement = () => {
        const next = Math.round((value - DOSE_STEP) * 10) / 10;
        if (next >= MINIMUM_DOSE) onChange(next.toFixed(1));
    };

    const increment = () => {
        const next = Math.round((value + DOSE_STEP) * 10) / 10;
        if (next <= MAXIMUM_DOSE) onChange(next.toFixed(1));
    };

    return (
        <div className="dose-stepper">
            <button
                className="stepper-btn"
                onClick={decrement}
                disabled={value <= MINIMUM_DOSE}
            >−</button>
            <span className="stepper-value">{selected} <span className="stepper-unit">{i18n('doseUnit')}</span></span>
            <button
                className="stepper-btn"
                onClick={increment}
                disabled={value >= MAXIMUM_DOSE}
            >+</button>
        </div>
    );
};

const DoseSelector = ({presets, selected, selectDose}) => {
    const {language} = useLanguage();
    const i18n = usei18n(language);

    return (
        <div className="selectors">
            <Presets presets={presets} selected={selected} selectDose={selectDose}/>
            <DoseStepper selected={selected} onChange={selectDose} i18n={i18n}/>
        </div>
    )
}

export default DoseSelector;
